export const ROUTES = {
    'HOME': '/home',
    'HOME_CHILDREN': '/home/*',
    'MAPPER': '/mapper',
    'HISTORY': '/history',
    'LOGIN': '/login',
}
